import {
  CardDescription,
  CardHeading,
  Customers,
  JourneyCard,
  JourneyCardDtl,
  JourneyCardIcon,
  OverallText,
} from "./OurJourneyCard.styles";

interface IOurJourneyCard {
  pinIconSrc: string;
  cardRef: any;
  data: {
    year: string;
    description: string;
    overall: string;
    pinIcon: string;
    bgColor: string;
    footerText: string;
  };
}

const OurJourneyCard = ({ data, cardRef, pinIconSrc }: IOurJourneyCard) => {
  const { year, description, overall, pinIcon, bgColor, footerText } = data;
  return (
    <JourneyCard bgColor={bgColor} ref={cardRef} className="journeyCard">
      {pinIcon && (
        <JourneyCardIcon>
          <img src={pinIconSrc} />
        </JourneyCardIcon>
      )}
      <JourneyCardDtl>
        {year && <CardHeading>{year}</CardHeading>}
        {description && <CardDescription>{description}</CardDescription>}
        {overall && <OverallText>Overall</OverallText>}
        {footerText && (
          <Customers dangerouslySetInnerHTML={{ __html: footerText }} />
        )}
      </JourneyCardDtl>
    </JourneyCard>
  );
};

export default OurJourneyCard;
